// extracted by mini-css-extract-plugin
module.exports = {"OrderPlacement":"OrderPlacement_OrderPlacement__IKHYX"};